import Api from "./base/api-base";

export default class SuppliersApi {
  // 取引先マスタ一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.suppliers,
    });
  }

  // 取引先マスタ登録
  // Parameter param オブジェクト
  store (params) {
    return Api.post({
      endpoint: Api.endpoint.suppliers,
      params: params
    });
  }

  // 取引先マスタ情報取得
  // Parameter id 数値型
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.suppliers,
      id: id
    });
  }

  // 取引先マスタ更新
  // Parameter id 数値型 param オブジェクト
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.suppliers,
      id: id,
      params: params
    });
  }

  // 取引先マスタ削除
  // Parameter id 数値型
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.suppliers,
      id: id
    });
  }
}
